/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { bankDetailsGetResponseSchema } from './bankDetailsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getBankDetails200Schema = z.lazy(() => bankDetailsGetResponseSchema);

/**
 * @description 505 response
 */
export const getBankDetails505Schema = z.any();

export const getBankDetailsQueryResponseSchema = z.lazy(() => getBankDetails200Schema);
